import PropTypes from "prop-types";
import React, { Component } from "react";
import { NavLink, Switch } from "react-router-dom";

export default class Footer extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {}
	componentWillUnmount() {}

	render() {
		let copyrightYear = new Date().getFullYear();
		return (
			<footer className="footer">
				<div className="container block-wrap behind-trees">
					<div className="d-flex flex-row flex-wrap">
						<div className="col-12 col-md-7">
							<h3 className="text-center w-100 pb-3">
								At Qwixskinz we are proud to be part of every athlete’s{" "}
								<b style={{ color: "var(--main-color)" }}>BEST</b> day.
							</h3>
						</div>
						<div className="col-12 col-md-5 text-center pb-3">
							<a
								href="https://www.facebook.com/qwixskinz"
								className="social-wrap facebook"
								target="_blank">
								<span className="icon">
									<object
										data="../../images/fa/brand/facebook-f.svg"
										type="image/svg+xml"
									/>
								</span>
							</a>
							{/* <a
								href="https://twitter.com/hashtag/qwixskinz"
								className="social-wrap twitter"
								target="_blank">
								<span className="icon">
									<object
										data="../../images/fa/brand/twitter.svg"
										type="image/svg+xml"
									/>
								</span>
							</a> */}
							<a
								href="https://www.instagram.com/qwixskinz/"
								className="social-wrap instagram"
								target="_blank">
								<span className="icon">
									<object
										data="../../images/fa/brand/instagram.svg"
										type="image/svg+xml"
									/>
								</span>
							</a>
							{/* <a
								href="javascript:void(0)"
								className="social-wrap youtube"
								target="_blank">
								<span className="icon">
									<object
										data="../../images/fa/brand/youtube.svg"
										type="image/svg+xml"
									/>
								</span>
							</a> */}
							<a
								href="https://vimeo.com/258637325"
								className="social-wrap vimeo"
								target="_blank">
								<span className="icon">
									<object
										data="../../images/fa/brand/vimeo-v.svg"
										type="image/svg+xml"
									/>
								</span>
							</a>
							<a
								href="http://www.pinterest.com/qwixskinz"
								className="social-wrap pinterestd d-none"
								target="_blank">
								<span className="icon">
									<object
										data="../../images/fa/brand/pinterest-p.svg"
										type="image/svg+xml"
									/>
								</span>
							</a>
						</div>
					</div>
				</div>
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<ul className="copyright">
								<li>
									<span>&copy; {copyrightYear} Qwixskinz</span>
								</li>
								<li>
									<span>All Rights Reserved</span>
								</li>
								<li>
									<NavLink
										to="/privacy-policy"
										className="footer-link"
										activeClassName="active">
										Privacy Policy
									</NavLink>
								</li>
								<li>
									<NavLink
										to="/terms-of-service"
										className="footer-link"
										activeClassName="active">
										Terms of Service
									</NavLink>
								</li>
								<li>
									<span>
										Developed by{" "}
										<a
											href="http://agilecollab.ca"
											target="_blank"
											style={{ color: "#f7931e", textDecoration: "none" }}>
											agilecollab
										</a>
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}
